import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useFormik } from 'formik';

import { updateOtherAdj } from 'api/Ledger';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';
import useModal from 'lib/hooks/useModal';

import Popover from 'components/shared/Popovers/Popover/Popover';

import { filterPrimaryProcedures } from '../../ElectronicInvoicing/lib/filterPrimaryProcedures';

import OtherAdjustmentsModal from './OtherAdjustmentsModal';

const Actions = ({ data }) => {
  const navigate = useNavigate();
  const { isOpen, openModal, closeModal } = useModal();
  const primaryProcedures = filterPrimaryProcedures(data?.procedures) || [];
  const procedures = primaryProcedures?.map((procedure) => ({
    ...procedure,
    other_adj: procedure?.other_adj || 0
  }));

  const formik = useFormik({
    initialValues: { procedures },
    onSubmit: (values) => mutateUpdateOtherAdj.mutate(values)
  });

  const options = [
    {
      label: 'Other Adjustments',
      icon: 'billing-mono',
      onClick: () => {
        openModal();
      }
    }
  ];

  const handleClose = () => {
    closeModal();
    formik.resetForm();
  };

  const mutateUpdateOtherAdj = useCustomMutation({
    mutationFn: (values) =>
      updateOtherAdj(navigate, {
        appointmentId: data?.appointment_id,
        invoiceId: data?.id,
        procedures: values.procedures
      }),
    successMessage: 'Other adjustments updated successfully',
    invalidateQueryKey: ['ledgers', 'internal_invoices', 'patientInvoices']
  });

  return (
    <>
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={options}
        isBorder={false}
      />
      {isOpen && (
        <OtherAdjustmentsModal
          isOpen={isOpen}
          handleClose={handleClose}
          formik={formik}
          onClose={closeModal}
        />
      )}
    </>
  );
};

export default Actions;
